(function($){
  $(document).ready(function() {

    /*
    * Responsive JS
    * http://www.javascriptkit.com/javatutors/matchmediamultiple.shtml
    */
    const xsMin = 480, // phone landscape 480->767
        smMin = 768, // tablet portrait 768->1023
        mdMin = 1024, // tablet landscape 1024->1239
        lgMin = 1240, // ordi 1240->*
        mqTelPortrait = 'only screen and (max-width: ' + (xsMin-1) + 'px)', // 0->479
        mqTelPaysage = 'only screen and (max-width: ' + (smMin-1) + 'px) and (min-width: ' + xsMin + 'px)', // 480->767
        mqTabletPortrait = 'only screen and (max-width: ' + (mdMin-1) + 'px) and (min-width: ' + smMin + 'px)', // 768->1023
        mqTabletPaysage = 'only screen and (max-width: ' + (lgMin-1) + 'px) and (min-width: ' + mdMin + 'px)', // 1024->1279
        mqOrdi = 'only screen and (min-width: ' + lgMin + 'px)', // 1280->++
        mqlist = [
            window.matchMedia(mqTelPortrait),
            window.matchMedia(mqTelPaysage),
            window.matchMedia(mqTabletPortrait),
            window.matchMedia(mqTabletPaysage),
            window.matchMedia(mqOrdi),
        ];

    const recherche = $('#recherche');
    const formchercher = $('#formchercher');

    const navTactile = function(e){
        e.preventDefault();
        $(this).delay(250).parent().toggleClass('open').siblings().removeClass('open');
    }

    function mediaqueryresponse(mql){
        const regexp_telPortrait = new RegExp('\\(max-width:\\s*' + (xsMin-1) + 'px\\)'),
              regexp_telPaysage = new RegExp('\\(max-width:\\s*' + (smMin-1) + 'px\\) and \\(min-width:\\s*' + xsMin + 'px\\)'),
              regexp_tabletPortrait = new RegExp('\\(max-width:\\s*' + (mdMin-1) + 'px\\) and \\(min-width:\\s*' + smMin + 'px\\)'),
              regexp_tabletPaysage = new RegExp('\\(max-width:\\s*' + (lgMin-1) + 'px\\) and \\(min-width:\\s*' + mdMin + 'px\\)'),
              regexp_ordi = new RegExp('\\(min-width:\\s*' + (lgMin) + 'px\\)');


        if (regexp_telPortrait.test(mql.media)){
            if (mql.matches){ // 0 -> 479
                $('.niv1 > .has_submenu').off('.tactile');
                $('.niv1 > .has_submenu').on('click.tactile', '> .menu_link', navTactile);
                formchercher.prependTo(recherche);
            }
        }
        else if (regexp_telPaysage.test(mql.media)){
            if (mql.matches){ // 480 -> 767
                $('.niv1 > .has_submenu').off('.tactile');
                $('.niv1 > .has_submenu').on('click.tactile', '> .menu_link', navTactile);
                formchercher.prependTo(recherche);
            }
        }
        else if (regexp_tabletPortrait.test(mql.media)){
            if (mql.matches){ // 768 -> 1023
                $('.niv1 > .has_submenu').off('.tactile');
                formchercher.appendTo($('body'));
            }
        }
        else if (regexp_tabletPaysage.test(mql.media)){
            if (mql.matches){ // 1024 -> 1279
                $('.niv1 > .has_submenu').off('.tactile');
                formchercher.appendTo($('body'));
            }
        }
        else if (regexp_ordi.test(mql.media)){
            if (mql.matches){ // 1280 -> *
                $('.niv1 > .has_submenu').off('.tactile');
                formchercher.appendTo($('body'));
            }
        }
    }

    for (var i=0; i<mqlist.length; i++){
        mediaqueryresponse(mqlist[i]);
        mqlist[i].addListener(mediaqueryresponse);
    }

  })

})(jQuery);
